import "./App.css";
import { useState, useEffect } from "react";
import { FilloutFullScreenEmbed } from "@fillout/react";
import "@fillout/react/style.css";
import { idPropMap, ftypes, contactNumberQP } from "./config/parameters.js";
import { getDataFromAirtable } from "./config/fetchdata.js";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

function App() {
  const queryParameters = new URLSearchParams(window.location.search);
  const ftype = queryParameters.get("ft");
  const contactNumber = queryParameters.get(contactNumberQP);
  var formid = idPropMap.get(ftypes.discover);
  const [data, setData] = useState({});

  var src = "";
  if (ftype) {
    src = ftype;
  }
  const linkWaitingList = `https://rdv.madigitalisation.fr/?ft=wl&src=${src}`;

  var dataHandler = (val) => {
    try {
      setData(val);
    } catch (err) {
      console.error(err);
    }
  };

  const popover = (
    <Popover id="popover-basic">
      <Popover.Header as="h3">Accès liste d'attente</Popover.Header>
      <Popover.Body>
        Tous les créneaux ont été <strong>réservés</strong> ?
        <br />
        Je t'invite à t'inscrire sur la liste d'attente ici :
        <a href="linkWaitingList"> {linkWaitingList}</a>
        <br />
        Tu seras prévenu(e) dès qu'une place se libère ! À bientôt ! 😊
      </Popover.Body>
    </Popover>
  );
  const Example = () => (
    <OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
      <Button variant="success" className="availButton">
        Planning complet?
      </Button>
    </OverlayTrigger>
  );

  useEffect(() => {
    if (contactNumber) {
      getDataFromAirtable(contactNumber, dataHandler);
    }
  }, ["contactNumber"]); //TODO

  if (ftype) {
    var fid = idPropMap.get(ftype);
    if (fid) {
      formid = fid;
    }
  }

  if (data) {
    //<Example />
    return (
      <div className="App">
        <div>
          <FilloutFullScreenEmbed
            filloutId={formid}
            inheritParameters
            parameters={{
              eml: data.email,
              prnm: data.firstname,
              nm: data.lastname,
              phn: data.phone, //,
              //compny: cdata.company,
            }}
          />
        </div>
      </div>
    );
  } else {
    return (
      <div className="App">
        <div>
          <FilloutFullScreenEmbed filloutId={formid} inheritParameters />
        </div>
      </div>
    );
  }
}

export default App;
